export const fieldset = {
  root: {
    background: 'rgba(0, 0, 0, 0)',
    legend: {
      borderWidth: '0',
    },
    colorScheme: {
      dark: {
        legend: {
          background: 'rgba(0, 0, 0, 0)',
        },
      },
    },
  },
}
